var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginPageBg1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 620,
    height: 127,
    viewBox: "0 0 620 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M336.403 52.6718C437.289 19.6081 527.806 34.9279 582.02 -54.5798C615.614 -110.043 629.697 -155.686 611.611 -217.958C583.242 -315.635 485.485 -331.356 384.828 -346.164C246.518 -366.51 127.874 -338.298 51.3292 -216.151C-25.2157 -94.004 -19.6798 65.0556 101.231 116.336C188.828 153.488 259.088 78.0102 336.403 52.6718Z",
    fill: "#F9B735"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPageBg1);
export default __webpack_public_path__ + "static/media/loginPageBg_1.b0e789a0f428c1a387012483c46fa0cd.svg";
export { ForwardRef as ReactComponent };